import { useState, useCallback } from 'react';

/**
 * Custom hook để quản lý trạng thái view của Agent Map
 */
export const useAgentMapView = ({
    setGetAgentMapDetail,
    selectMaps
}: {
    setGetAgentMapDetail: (id: number | number[]) => void,
    selectMaps: (mapIds: number[], forceRefresh?: boolean, preserveOnline?: boolean) => void
}) => {
    // State cho online map
    const [onlineMapSelected, setOnlineMapSelected] = useState<boolean>(false);
    const [onlyOnlineMapSelected, setOnlyOnlineMapSelected] = useState<boolean>(false);
    const [renderMultipleAgentMap, setRenderMultipleAgentMap] = useState<boolean>(false);

    /**
     * Xử lý thay đổi chọn bản đồ
     */
    const handleMapSelectionChange = useCallback((
        checkedValues: string[],
        options: {
            resetAllData: () => void,
            defaultChartData: any,
            setChartData: (data: any) => void,
            refetchOnlineSeats: () => void
        }
    ) => {
        const { resetAllData, defaultChartData, setChartData, refetchOnlineSeats } = options;

        // Xử lý khi không chọn bản đồ nào
        if (checkedValues.length === 0) {
            setGetAgentMapDetail(0);
            setRenderMultipleAgentMap(false);
            setOnlyOnlineMapSelected(false);
            selectMaps([], false, false);
            setChartData(defaultChartData);
            setOnlineMapSelected(false);
            return;
        }

        // Kiểm tra xem có chọn bản đồ online không
        const isOnlineSelected = checkedValues.includes("online");
        setOnlineMapSelected(isOnlineSelected);

        // Lọc ra các bản đồ thường (không phải online)
        const numericMapIds = checkedValues
            .filter(id => id !== "online")
            .map(id => parseInt(id))
            .filter(id => !isNaN(id));

        // Xác định nếu chỉ chọn mỗi bản đồ online
        const onlyOnline = isOnlineSelected && numericMapIds.length === 0;

        setOnlyOnlineMapSelected(onlyOnline);

        // Cập nhật dữ liệu online nếu được chọn
        if (isOnlineSelected) {

            refetchOnlineSeats();
        }

        // Thiết lập chế độ hiển thị dựa trên lựa chọn
        if (numericMapIds.length > 1 || (isOnlineSelected && numericMapIds.length > 0)) {
            // Nhiều bản đồ hoặc có cả online + bản đồ thường
            setRenderMultipleAgentMap(true);
            setGetAgentMapDetail(numericMapIds);

        } else if (numericMapIds.length === 1 && !isOnlineSelected) {
            // Chỉ một bản đồ thường và không có online
            setGetAgentMapDetail(numericMapIds[0]);
            setRenderMultipleAgentMap(false);

        } else if (onlyOnline) {
            // Chỉ có bản đồ online
            setRenderMultipleAgentMap(false);

        }

        // Cập nhật dữ liệu bản đồ
        if (numericMapIds.length > 0) {
            // Đối với bản đồ thường, cập nhật Redux store và giữ lại bản đồ online nếu cần

            selectMaps(numericMapIds, true, isOnlineSelected);
        } else if (onlyOnline) {
            // Đối với bản đồ online duy nhất, xóa bản đồ thường nhưng giữ lại bản đồ online

            selectMaps([], false, true);
        }
    }, [selectMaps, setGetAgentMapDetail]);

    return {
        onlineMapSelected,
        setOnlineMapSelected,
        onlyOnlineMapSelected,
        setOnlyOnlineMapSelected,
        renderMultipleAgentMap,
        setRenderMultipleAgentMap,
        handleMapSelectionChange
    };
};
